/* Headeren gjør seg solid når man har rullet litt, og skjuler seg når man
   ruller nedover. Framdriftslinjen viser hvor langt ned på siden man er. */

import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import { $ } from './verktoy.js';

export function startHeader(erMenyApen) {
  const topplinje = $('.topplinje');
  const framdrift = $('.framdrift');
  let forrigeY = 0;

  ScrollTrigger.create({
    start: 0,
    end: 'max',
    onUpdate: selv => {
      const y = selv.scroll();
      topplinje.classList.toggle('fast', y > 60);
      topplinje.classList.toggle('skjult', y > forrigeY && y > 400 && !erMenyApen());
      forrigeY = y;
      gsap.set(framdrift, { scaleX: selv.progress });
    },
  });

  return { vis: () => topplinje.classList.remove('skjult') };
}
